import { createContext } from 'react';
import type { AudioPlayer } from '@/shared/lib/audio/types';
import type { IdentityProvider } from '../identity/types';
import type { Platform } from '../types';

export type PlatformContextValue = {
  platform: Platform;
  apiBaseUrl: string;
  identity: IdentityProvider;
  /**
   * Per-platform `AudioPlayer`. Today every platform gets the procedural
   * Web Audio synth — the seam exists so a native client (Capacitor
   * NativeAudio, Tauri rodio) can drop in without touching consumer code.
   */
  audio: AudioPlayer;
  /** Discord Activity instance id; `null` everywhere else and during SDK handshake. */
  discordInstanceId: string | null;
  /** SDK boot status; `n/a` outside Discord. Lobby renders Retry on `failed`. */
  discordSdkStatus: 'pending' | 'ready' | 'failed' | 'n/a';
  /** Re-attempt SDK boot after `failed`. No-op outside Discord. */
  retryDiscordSdk: () => void;
};

// `null` sentinel so hooks can throw a clear "outside provider" error.
export const PlatformContext = createContext<PlatformContextValue | null>(null);
